<template>
  <div id="box" :style="'background-image:url('+CShttp+shopDetail.shop_images+') !important'">
    <div class="backShow"></div>
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack2.png" alt />
    </div>
    <div class="searchBox">
      <div class="cancelShop" v-if="shopDetail.follow==1" v-on:click="cancelShop">
        <img src="../assets/already.png" alt />
        已关注
      </div>
      <div class="addShop" v-if="shopDetail.follow==0" v-on:click="addShop">
        <img src="../assets/add.png" alt />
        关注
      </div>
    </div>
    <div class="shopName">
      <div class="shopImg">
        <img :src="CShttp+shopDetail.shop_icon_image" alt />
      </div>
      <div class="Name">
        <div class="NameText">{{shopDetail.name}}</div>
        <div class="shopInfo">
          <div>
            <span>{{shopDetail.shop_class_list}}</span>
            <span class="shopInfoCenter">|</span>
            <span>月销量{{shopDetail.xiaoliang?shopDetail.xiaoliang:0}}</span>
          </div>
          <div>{{(shopDetail.juli/1000).toFixed(2)}}km</div>
        </div>
      </div>
    </div>
    <div class="shopLocationInfo Location">
      <div>
        <router-link
          :to="{ name: 'mapLocation', query: { endLocation: {lng: shopDetail.longitude, lat: shopDetail.latitude }}}"
        >
          <img src="../assets/map02.png" alt />
          <span>{{shopDetail.shop_area}}</span>
        </router-link>
      </div>
      <div style="line-height:0">
        <a :href="'tel:'+shopDetail.shop_phone">
          <img src="../assets/phone.png" alt />
        </a>
      </div>
    </div>
    <div class="shopLocationInfo">
      <div>
        <img src="../assets/time.png" alt />
        <span>{{shopDetail.shop_business_hours}}</span>
      </div>
      <div>
        <img src alt style="display:none" />
      </div>
    </div>
    <div class="shopLocationInfo" v-if="shopDetail.is_water=='是'">
      <div>
        <img src="../assets/water03.png" alt />
        <span>取水点</span>
      </div>
      <div>
        <img src alt style="display:none" />
      </div>
    </div>
    <router-link :to="{ name: 'ShopCertification', query: { info: shopDetail}}">
      <div class="shopLocationInfo">
        <div>
          <img src="../assets/shopInfo.png" alt />
          <span>查看商家资质</span>
        </div>
        <div>
          <img src="../assets/right.png" alt />
        </div>
      </div>
    </router-link>
    <div>
      <div class="shopLocationInfo" style="border:none">
        <div>
          <img src="../assets/shopCoupon.png" alt />
          <span>店铺优惠券（{{ShopCouponList.length}}张）</span>
        </div>
        <div>
          <img src style="display:none" alt />
        </div>
      </div>
      <div class="couponList">
        <div v-for="(item,index) in ShopCouponList" :key="index">
          <MycouponList type="MyAttention" IconImg :CouponInfo="item" class="coupon"></MycouponList>
        </div>
      </div>
      <div class="packUp" data-id="0" v-on:click="packUp">
        点击收起优惠卷
        <img data-id="0" src="../assets/top.png" alt />
      </div>
      <div class="sentOut" style="display:none" data-id="1" v-on:click="packUp">
        点击展示优惠卷
        <img data-id="1" src="../assets/bottom.png" alt />
      </div>
    </div>
    <div class="content">
      <div class="Title">店铺介绍</div>
      <div>{{shopDetail.shop_introduce_content}}</div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import MycouponList from "../components/MycouponList.vue";
import wx from "weixin-jsapi";
import $ from "jquery";
export default {
  name: "",
  data() {
    return {
      id: "",
      ShopCouponList: [],
      CShttp: this.$store.state.CShttp,
      wxJSSDK: this.$store.state.wxJSSDK,
      shopDetail: "",
      progress: 0.6, //进度条
      //swiper左右滑动
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        // loop:true,
        speed: 600 //config参数同swiper4,与官网一致
      }
    };
  },
  components: { MycouponList },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.id = this.$route.query.id;
    this.GetShopDetail();
  },
  methods: {
    GetWx() {
       var that = this;
        var IsPhone= /iphone/.test(navigator.userAgent.toLowerCase()); //判断是不是苹果
      this.$http
        .get("/api/shop/get_SignPackage", {
          params: {
            url: IsPhone?encodeURIComponent(window.entryUrl):encodeURIComponent(location.href)
          },
        })
        .then((res) => {
          console.log(res.data.msg);
          that.$store.commit("wxJSSDK", res.data.msg);
          wx.config({
            debug: false, // true:调试时候弹窗
            appId: res.data.msg.appId, // 微信appid
            timestamp: res.data.msg.timestamp, // 时间戳
            nonceStr: res.data.msg.nonceStr, // 随机字符串
            signature: res.data.msg.signature, // 签名
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "onMenuShareAppMessage", //获取地理位置
              'updateAppMessageShareData'
            ],
          });
        });
      wx.ready(function () {
        wx.checkJsApi({
          jsApiList: ["updateAppMessageShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function(res) {
            console.log(res)
            // 以键值对的形式返回，可用的api值true，不可用为false
            // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          }
        });
        //需在用户可能点击分享按钮前就先调用
        wx.onMenuShareAppMessage({
          title: "分享商家", // 分享标题
          desc:
            "我抢到了我们附近（" +
            that.shopDetail.name +
            "）史无前例的福利，送给你啦!", // 分享描述
          link:
            window.location.origin +
            "/redirect.html?shareRedirect=" +
            encodeURIComponent(
              "https://zqconsumer.zeego2.cc?type=shopIndex&id=" + that.id + "#/"
            ), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.CShttp + that.shopDetail.shop_icon_image, // 分享图标
          success: function() {
            // alert("分享成功",location.href+"&type=shopIndex")
            // 设置成功
          }
        });
      });
      wx.error(function () {
        console.log("失败");
      });
    },
    back() {
      this.$router.go(-1);
    },
    packUp(e) {
      console.log(e.target.dataset.id);
      var id = e.target.dataset.id;
      $(".couponList").css({
        display: id == 0 ? "none" : "block"
      });
      $(id != 0 ? ".sentOut" : ".packUp").css({
        display: "none"
      });
      $(id == 0 ? ".sentOut" : ".packUp").css({
        display: "flex"
      });
    },
    //获取商店信息
    GetShopDetail() {
      this.$http
        .get("/api/shop/find_juli", {
          params: {
            shop_id: this.id,
            uid: this.$store.state.useId,
            log: this.$store.state.log,
            lat: this.$store.state.lat
          }
        })
        .then(res => {
          console.log(res.data);
          res.data.data.action.shop_introduce_content = res.data.data.action
            .shop_introduce_content
            ? res.data.data.action.shop_introduce_content.replace(/<.*?>/gi, "")
            : "";
          this.shopDetail = res.data.data.action;
          this.GetShopCoupon();
          this.GetWx();
        });
    },
    //获取商店优惠券信息
    GetShopCoupon() {
      this.$http
        .get("/api/coupon/shop_coupon_hidden/shop_id/", {
          params: {
            shop_id: this.id
          }
        })
        .then(res => {
          console.log(res.data);
          res.data.data.action.data.map(res => {
            res.shop_info = { name: this.shopDetail.name };
            this.ShopCouponList.push(res);
          });
          // this.ShopCouponList = res.data.data.action;
        });
    },
    //关注商店
    addShop() {
      this.$http
        .get("/api/shop/follow", {
          params: {
            shop_id: this.id,
            uid: this.$store.state.useId
          }
        })
        .then(res => {
          console.log(res.data);
          if (res.data.code == 1) {
            this.shopDetail.follow = 1;
          }
        });
    },
    //取消关注商店
    cancelShop() {
      this.$http
        .get("/api/shop/cancel_follow", {
          params: {
            shop_id: this.id,
            uid: this.$store.state.useId
          }
        })
        .then(res => {
          console.log(res.data);
          if (res.data.code == 1) {
            this.shopDetail.follow = 0;
          }
        });
    }
  }
};
</script>
<style lang='scss' scoped>
#box {
  width: 100%;
  // height: 90%;
  // overflow: scroll;
  // background-image: url(../assets/shopBanner.jpg);
  background-repeat: no-repeat;
  background-size: 100% 2.3rem;
  display: inline-block;
  padding-bottom: 0.5rem;
  background-color: white;
}
.Location a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.back {
  position: absolute;
  top: 0.5rem;
  left: 0.2rem;
  width: 0.7rem;
  height: 0.7rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.searchBox {
  height: 0.8rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-radius: 0.4rem;
  padding-left: 0.3rem;
  font-size: 0.24rem;
  margin: 0.3rem 0.3rem 0 0.3rem;
}
.searchBox > div {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 0.7rem;
  height: 0.8rem;
  width: 2rem;
  border-radius: 0.4rem;
  z-index: 100;
}
.searchBox > div img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0;
}
.searchBox > .cancelShop {
  background: #e73d35;
  color: white;
}
.searchBox > .addShop {
  background: white;
  color: #cd160d;
}
.search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.searchBox input {
  border: none;
  outline: none;
  -webkit-appearance: none;
}
.clickSearch {
  width: 1.9rem;
  height: 100%;
  background-image: linear-gradient(to right, #e73d35, #bc170f);
  opacity: 1;
  color: white;
  font-size: 0.32rem;
  border-radius: 0.4rem;
  text-align: center;
  line-height: 0.8rem;
}
.shopName {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 0.3rem;
  padding-top: 0.63rem;
  margin-bottom: 0.5rem;
}
.backShow {
  width: 100%;
  height: 2.3rem;
  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.5));
  position: absolute;
  left: 0;
  top: 0;
}
.shopName > .shopImg {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 100;
}
.shopImg > img {
  width: 1.2rem;
  height: 1.2rem;
  flex-shrink: 0;
}
.Name {
  width: 100%;
  margin-left: 0.3rem;
  position: relative;
}
.NameText {
  font-size: 0.32rem;
  color: white;
  line-height: 0.6rem;
  font-weight: 700;
}
.shopInfo {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.24rem;
  color: #636363;
  height: 0.6rem;
}
.shopInfoCenter {
  display: inline-block;
  margin: 0 0.2rem;
}
.swiperBox {
  margin-left: 0.3rem;
  margin-top: 0.5rem;
}
.swiperTicket {
  width: 1.8rem;
  height: 2.18rem;
  background-image: url(../assets/ticket01.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 0.1rem;
}
.swiperTicket > div {
  text-align: center;
}
.ticketMoney {
  line-height: 0.68rem;
  font-size: 0.5rem;
  color: #4a0300;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.ticketMoney > span:nth-child(1) {
  font-size: 0.24rem;
  line-height: 0.6rem;
}
.useGoodMust,
.useMust {
  background: #fcd4d2;
  font-size: 0.22rem;
  color: #cc1a1a;
  margin: 0 0.1rem;
  border-radius: 0.2rem;
  height: 0.34rem;
  line-height: 0.34rem;
}
.ticketType {
  font-size: 0.22rem;
  color: #724f4d;
  line-height: 0.37rem;
  padding-top: 0.08rem;
  margin: 0 0.1rem;
  // border-bottom: 1px dashed #E7786F
}
.ticketClick {
  font-size: 0.28rem;
  line-height: 0.6rem;
  color: #c91111;
}
.ticketGood {
  margin: 0.34rem 0.3rem 0 0.3rem;
}
.ticketTitle {
  font-size: 0.3rem;
  color: #4a0300;
  line-height: 0.9rem;
}
.ticketGoodBox {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.shopLocationInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  line-height: 0.8rem;
  margin: 0 0.4rem;
  padding: 0.2rem 0;
}
.shopLocationInfo > div {
  display: flex;
  align-items: center;
}
.shopLocationInfo > div:nth-child(1) {
  width: 80%;
  font-size: 0.28rem;
}
.shopLocationInfo > div span {
  line-height: 0.4rem;
}
.shopLocationInfo > div img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.2rem;
  display: inline-block;
}
.coupon {
  margin: 0.1rem 0.4rem;
}
.packUp,
.sentOut {
  width: 100%;
  color: #cd160d;
  font-size: 0.26rem;
  text-align: center;
  height: 0.9rem;
  line-height: 0.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.packUp img,
.sentOut img {
  width: 0.4rem;
  height: 0.4rem;
}
.content {
  margin: 0 0.4rem;
  padding: 0.3rem;
  background-color: #f5f5f5;
  border-radius: 0.2rem;
  padding-top: 0;
  color: #636363;
  font-size: 0.24rem;
}
.Title {
  line-height: 0.9rem;
  font-size: 0.28rem;
  color: #333333;
}
</style>

